// Convert UTC date string to user's local timezone
export const formatLocalDateTime = (utcDateString: string, options?: Intl.DateTimeFormatOptions): string => {
  // Ensure UTC string has 'Z' suffix for proper parsing
  const dateStr = utcDateString.endsWith('Z') ? utcDateString : utcDateString + 'Z';
  const date = new Date(dateStr);
  return date.toLocaleString('en-GB', options || {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatLocalDate = (utcDateString: string): string => {
  // Ensure UTC string has 'Z' suffix for proper parsing
  const dateStr = utcDateString.endsWith('Z') ? utcDateString : utcDateString + 'Z';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatLocalTime = (utcDateString: string): string => {
  // Ensure UTC string has 'Z' suffix for proper parsing
  const dateStr = utcDateString.endsWith('Z') ? utcDateString : utcDateString + 'Z';
  const date = new Date(dateStr);
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format duration in hours as "X h Y m" instead of decimal
export const formatDuration = (hours: number): string => {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  
  if (h === 0) return `${m} m`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} m`;
};
